export function issueReportStatusLabel(status: number, t: any) {
  switch (status) {
    case 0:
      return t("learning.titles.not_started", "Not Started")
    case 1:
      return t("global.new", "New")
    case 2:
      return t("global.planned", "Planned")
    case 3:
      return t("global.ongoing", "Ongoing")
    case 4:
      return t("global.fixed", "Fixed")
    case 5:
      return t("global.completed", "Completed")
    default:
      return "-"
  }
}
